module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /usr/local/Cellar/go/1.11/src/github.com/durgeshm/ruebarue/~/axios/index.js
// module id = 38
// module chunks = 1